import { render, staticRenderFns } from "./RegistryOperations.vue?vue&type=template&id=99347a80&scoped=true"
import script from "./RegistryOperations.vue?vue&type=script&lang=js"
export * from "./RegistryOperations.vue?vue&type=script&lang=js"
import style0 from "./RegistryOperations.vue?vue&type=style&index=0&id=99347a80&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99347a80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99347a80')) {
      api.createRecord('99347a80', component.options)
    } else {
      api.reload('99347a80', component.options)
    }
    module.hot.accept("./RegistryOperations.vue?vue&type=template&id=99347a80&scoped=true", function () {
      api.rerender('99347a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryOperations.vue"
export default component.exports